import { ExpenseClaimStatus } from '../../models/expense-claim/expense-claim';

/** Expense claim status → translated label (#5800). */
export function expenseClaimStatusLabel(status: ExpenseClaimStatus, t: (key: string, fallback: string) => string): string {
  switch (status) {
    case ExpenseClaimStatus.Draft:
      return t('ExpenseClaim_Status_Draft', 'Draft');
    case ExpenseClaimStatus.InApproval:
      return t('ExpenseClaim_Status_InApproval', 'In approval');
    case ExpenseClaimStatus.AccountingReview:
      return t('ExpenseClaim_Status_AccountingReview', 'Accounting review');
    case ExpenseClaimStatus.Posted:
      return t('ExpenseClaim_Status_Posted', 'Posted');
    case ExpenseClaimStatus.PartiallySettled:
      return t('ExpenseClaim_Status_PartiallySettled', 'Partially settled');
    case ExpenseClaimStatus.Settled:
      return t('ExpenseClaim_Status_Settled', 'Settled');
    default:
      return '';
  }
}

/** Expense claim status → p-tag severity. */
export function expenseClaimStatusSeverity(status: ExpenseClaimStatus): 'success' | 'secondary' | 'warn' | 'info' | 'danger' {
  switch (status) {
    case ExpenseClaimStatus.Draft:
      return 'warn';
    case ExpenseClaimStatus.InApproval:
    case ExpenseClaimStatus.AccountingReview:
      return 'info';
    case ExpenseClaimStatus.Posted:
    case ExpenseClaimStatus.PartiallySettled:
      return 'success';
    default:
      return 'secondary';
  }
}

/** All statuses, in lifecycle order, for filters and the stepper. */
export const EXPENSE_CLAIM_STATUSES: ExpenseClaimStatus[] = [
  ExpenseClaimStatus.Draft,
  ExpenseClaimStatus.InApproval,
  ExpenseClaimStatus.AccountingReview,
  ExpenseClaimStatus.Posted,
  ExpenseClaimStatus.PartiallySettled,
  ExpenseClaimStatus.Settled,
];
